import { render } from "./VF-buttonAuth.vue?vue&type=template&id=6f266212"
import script from "./VF-buttonAuth.vue?vue&type=script&lang=js"
export * from "./VF-buttonAuth.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__